import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
//import {BranchElement} from "../../Models/ApplicationModels/BranchModel";
import {ItemMasterBasic1_VitalElement} from "../models/ItemMasterBasic1_VitalModel";

import { environment } from '../../environments/environment';

@Injectable()
export class ItemMasterBasic1_VitalService {

  ///import { environment } from '../../../environments/environment';
   private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  /////////////////////////  ------------  GET ALL ------------


  getAllItemBasic1Vital() {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/ItemBasic1_Vital/GetAllItemBasic1Vital",httpOptions);
  }


  ///////////////////////  ----------- GET ALL BY ID -----------


  getAllItemBasic1VitalByItemId(  itemid:number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/ItemBasic1_Vital/GetAllItemBasic1VitalByItemId?itemid="+itemid,httpOptions);
  }

  getAllItemBasic1VitalByItemProductTypeId(  pids:number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/ItemBasic1_Vital/GetAllItemBasic1VitalByPId?pids="+pids,httpOptions);
  }

  /////////////////////////////  ------------- CURD -----------------



  addItemBasic1Vital(app :ItemMasterBasic1_VitalElement) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  return this.http.post(""+this.apiUrl+"/ItemBasic1_Vital/AddItemBasic1Vital",
  JSON.stringify(app),
   httpOptions
  )
  }

  
  
  saveMidItemIdMAPPINGUpdateData(data) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.post<any>(""+this.apiUrl+"/ItemBasic1_Vital/UploadComponentPermissionMidItemId",data, {
      reportProgress: true,
      observe: 'events'
    });
  }

  
  getAllMidItemIdMAPPINGData( mid:number , stat : number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/ItemBasic1_Vital/GetAllMidItemIdMAPPING?AdmissionMasterId="+mid+"&Stat="+stat,httpOptions);
  }


  ///  PrivilegeID  IsPermitted  CreatedBy
  UpdateMidItemIdMapping( pid:number , ies : number,  cby : number   ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/ItemBasic1_Vital/UpdateMidItemIdMapping?PrivilegeID="+pid+"&IsPermitted="+ies+"&CreatedBy="+cby,httpOptions);
  }



  
  uploadPackageItemIdData(data) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.post<any>(""+this.apiUrl+"/ItemBasic1_Vital/UploadPackageItemId",data, {
      reportProgress: true,
      observe: 'events'
    });
  }

  
  getAllPackageData(  mid:number  ) {
    var httpOptions = {
    headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',
    })

  };

  return this.http.get(""+this.apiUrl+"/ItemBasic1_Vital/GetAllPackageByItemId?ItemId="+mid,httpOptions);

  }


}
